import React from "react";

const FileInputField = React.forwardRef(
  (
    {
      label,
      id,
      extra = "",
      variant = "auth",
      disabled = false,
      error, // only used for error text
      className = "",
      ...rest
    },
    ref
  ) => {
    return (
      <div className={`${extra}`}>
        {label && (
          <label
            htmlFor={id}
            className={`text-sm text-navy-700 dark:text-white ${
              variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
            }`}
          >
            {label}
          </label>
        )}

        <input
          ref={ref}
          id={id}
          type="file"
          disabled={disabled}
          className={`mt-0.5 flex w-full cursor-pointer items-center justify-center rounded-md border border-gray-200 bg-white/0 text-sm outline-none
            file:mr-4 file:cursor-pointer file:rounded-md file:border-0 file:bg-brand-400 file:bg-brand-500 file:px-4 
            file:py-2 file:text-sm file:font-semibold file:text-white hover:file:bg-brand-600 dark:border-white/10 dark:text-white dark:hover:file:bg-brand-300 ${className}`}
          {...rest}
        />

        {error && (
          <p className="ml-1.5 mt-0.5 text-sm text-red-500">
            {typeof error === "string" ? error : error.message}
          </p>
        )}
      </div>
    );
  }
);

FileInputField.displayName = "FileInputField";
export default FileInputField;
